import { render } from "./CollapseButton.vue?vue&type=template&id=ddeaa806&scoped=true&ts=true"
import script from "./CollapseButton.vue?vue&type=script&lang=ts"
export * from "./CollapseButton.vue?vue&type=script&lang=ts"

import "./CollapseButton.vue?vue&type=style&index=0&id=ddeaa806&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddeaa806"]])

export default __exports__